module.exports = __webpack_public_path__ + "img/SamsungA10.16940ec1.png";